import { __assign } from "tslib";
import React, { memo } from 'react';
import { Field } from 'react-final-form';
import Button from '@mercell/button-react';
import stringify from 'fast-safe-stringify';
export var ButtonField = memo(function (_a) {
    var field = _a.field, name = _a.name;
    var _b = field, buttonScheme = _b.buttonScheme, _c = _b.fieldWrapperProperties, fieldWrapperProperties = _c === void 0 ? {} : _c, _d = _b.elementProperties, buttonProperties = _d === void 0 ? {} : _d, linkButton = _b.linkButton, iconSettings = _b.iconSettings, small = _b.small, text = _b.text, type = _b.type, disabled = _b.disabled;
    return linkButton ? (React.createElement(Field, { name: name, type: type }, function (_a) {
        var input = _a.input;
        return (React.createElement("div", __assign({}, fieldWrapperProperties),
            React.createElement("a", __assign({}, (linkButton.linkProperties || {}), { href: linkButton.linkAddress }),
                React.createElement(Button, __assign({}, input, buttonProperties, { small: small, iconSettings: iconSettings, disabled: buttonProperties.disabled || disabled, ref: buttonProperties.ref, scheme: buttonScheme, id: name, type: type }), text))));
    })) : (React.createElement(Field, { name: name, type: type }, function (_a) {
        var input = _a.input;
        return (React.createElement("div", __assign({}, fieldWrapperProperties),
            React.createElement(Button, __assign({}, input, buttonProperties, { small: small, iconSettings: iconSettings, ref: buttonProperties.ref, scheme: buttonScheme, id: name, type: type }), text)));
    }));
}, function (prevProps, nextProps) {
    try {
        return stringify(prevProps) === stringify(nextProps);
    }
    catch (e) {
        console.warn("ButtonField: ".concat(e));
        return false;
    }
});
ButtonField.displayName = 'ButtonField';
